<script>
import Modal from './Modal.vue'

export default {
    components: {
        Modal
    },

    props: {
        message: {
            type: String,
            default: 'Are you sure ?'
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        confirm() {
            this.$emit('confirmed')
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Confirmation">

        <div class="mb-4">
            <h5>{{ this.message }}</h5>
        </div>

        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <button class="button success" type="button" @click="confirm">Yes</button>
            </div>

            <div class="cell shrink">
                <button class="button warning" type="button" @click="toggleModal">No</button>
            </div>
        </div>
    </modal>
</template>